import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line
import AgencyLandingPage from "pages/AgencyLandingPage.js";
import AdminBoard from "pages/AdminBoard.js";
import AdminLogin from "pages/AdminLogin.js";
import ListVendors from "pages/ListVendors.js"; // custom page
import ShowPrice from "pages/ShowPrice.js"; // custom page
import UserForm from "pages/UserForm.js"; // custom page
import UserDomForm from "pages/UserDomForm.js"; // custom page
import Checkout from "pages/Checkout.js"; // custom page
import Success from "pages/Success.js"; // custom page

import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

export default function App() {
  // return <AnimationRevealPage disabled></AnimationRevealPage>;
  return (
    <Router>
      <Switch>
        <Route path="/list-vendors" exact>
          <ListVendors />
        </Route>
        <Route path="/show-price" exact>
          <ShowPrice />
        </Route>
        <Route path="/" exact>
          <AgencyLandingPage />
        </Route>
        <Route path="/user-details">
          <UserForm />
        </Route>
        <Route path="/user-domestic-details">
          <UserDomForm />
        </Route>
        <Route path="/admin-login">
          <AdminLogin />
        </Route>
        <Route path="/admin-board">
          <AdminBoard />
        </Route>
        <Route path="/thankyou">
          <Success />
        </Route>
        <Route path="/checkout/:oid" exact strict>
          <Checkout />
        </Route>
        <Route exact path="/checkout/">
            <Redirect to="/" />
        </Route>
      </Switch>
    </Router>
  );
}
